import { Component } from '@angular/core';
import { AppMainComponent } from '../app.main.component';
import { UserService } from '../service/userservice';
import { NotificationService } from './notificationService';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent {

  globalFilterInputNotification = '';
  checkedAll = false;
  assestBaseUrl: string = environment.assestsBasePath;

  constructor(private notificationService: NotificationService, public app: AppMainComponent, private userService: UserService) { }

  showDetail(n) {
    this.app.selectedNotification = n;
    this.app.displayNote = true;
    this.app.displayAlerts = false;
    if(this.app.notificationSideMenu){
        this.app.notificationSideMenu.destroyModal();
    }
  }

  markAsRead() {
    let selectedNotifications = [];
    for(let n of this.app.notifications) {
      if(n.checked) {
        selectedNotifications.push(n.id);
      }
    }
    this.notificationService.markReadNotificationAll(selectedNotifications).then(ret =>{
      ////console.log(ret);
      this.app.getNotifications();
    })
    this.app.showMARButton = false;
  }

  showMarkAsRead() {
    this.app.showMARButton = false;
    for(let n of this.app.notifications) {
      if(n.checked) {
        this.checkedAll = false;
        this.app.showMARButton = true;
        break;
      }
    }
  }

  checkAll() {
    if(this.checkedAll){
      for(let n of this.app.notifications) {
        n.checked = true;
      }
      this.app.showMARButton = true;
    } else {
      for(let n of this.app.notifications) {
        n.checked = false;
      }
      this.app.showMARButton = false;
    }
  }

}
